module.exports = __webpack_public_path__ + "static/es-173eaa04cc186ac4bf503e39f530965a.png";